export function getBody(obj) {
  const formBody = [];
  for (var prop in obj) {
    var encodedKey = (prop);
    var encodedValue = encodeURIComponent(obj[prop]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  return formBody.join("&");
}